import { Box, Typography } from "@mui/material";
import { PublicationSelectorOrder, PublicationSelectorType } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import React from "react";
import { useTranslation } from "react-i18next";
import { BasePublicationSelectorDrawer, PublicationSelectorFilterOptions, PublicationSelectorProps } from "views/knowledge/publication/drawers/BasePublicationSelectorDrawer";

////////////////////////////////////////////////////////////////////////////////

interface IProps {
    onlyPostPublications?: boolean;
    userId?: string; //Se não informado, será visualizado o acesso do usuário logado.
}

////////////////////////////////////////////////////////////////////////////////

export const PublicationSelectorDrawer: React.FC<PublicationSelectorProps & IProps> = ({ ...props }) => {
    const api = useCoreApi();
    const { t } = useTranslation("knowledge");

    const handleGetdata = ({ signal, ...filter }: PublicationSelectorFilterOptions) => {
        var emptySearch = filter.searchText == "";

        return api.v1.knowledgeSelectors.publications({
            ...filter,
            selectorType: PublicationSelectorType.Any,
            listPublicationId: null,
            onlyPostPublications: props.onlyPostPublications ?? false,
            orderBy: emptySearch ? PublicationSelectorOrder.Latest : PublicationSelectorOrder.Title,
            userId: props.userId ?? null
        }, { signal: signal });
    };

    return <BasePublicationSelectorDrawer
        onGetData={handleGetdata}
        showCounter={(data) => data.searchText != ""}
        contentHeader={
            (props) => props.searchText == ""
                ? <Box mt={1}><Typography variant="subtitle1">{t("Selectors.Publication.ShowingMoreRecent")}</Typography></Box>
                : undefined
        }
        {...props}
    />;
};
